module.exports = __webpack_public_path__ + "static/media/codebot_peripherals2.1879b9b4.svg";